import { render, staticRenderFns } from "./distinctFields.vue?vue&type=template&id=996b1848&scoped=true"
import script from "./distinctFields.vue?vue&type=script&lang=js"
export * from "./distinctFields.vue?vue&type=script&lang=js"
import style0 from "./distinctFields.vue?vue&type=style&index=0&id=996b1848&prod&lang=css"
import style1 from "./distinctFields.vue?vue&type=style&index=1&id=996b1848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996b1848",
  null
  
)

export default component.exports